import React from 'react';
import PropTypes from 'prop-types';

import Title from '../Title';
import Description from '../Description';
import SocialMediumItems from '../SocialMediumItems';

const SocialMediaBody = ({settings, onClick, socialMediumItems}) => {
    const {title, description} = settings;

    return (
        <div>
            <Title title={title}/>
            <Description description={description}/>
            <SocialMediumItems mediums={socialMediumItems} onClick={onClick}/>
        </div>
    );
};


SocialMediaBody.propTypes = {
    settings: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.array
    }).isRequired,
    socialMediumItems: PropTypes.arrayOf(PropTypes.shape({
        medium: PropTypes.string.isRequired,
        isVisited: PropTypes.bool,
        isLoading: PropTypes.bool
    })).isRequired,
    onClick: PropTypes.func.isRequired
};

export default SocialMediaBody;



// WEBPACK FOOTER //
// ./src/components/SocialMediaBody/index.js